import { render, staticRenderFns } from "./DefaultWrapper.vue?vue&type=template&id=388be174&scoped=true&"
import script from "./DefaultWrapper.vue?vue&type=script&lang=js&"
export * from "./DefaultWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DefaultWrapper.vue?vue&type=style&index=0&id=388be174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388be174",
  null
  
)

export default component.exports